export const rpmPatientAction = {
  setSelectedRpmPatient: (state, action) => {
    state.selectedRpmPatient = action.payload;
  },

  setRpmReport: (state, action) => {
    state.rpmReport = action.payload;
  },

  setRpmReportUrl: (state, action) => {
    state.rpmReportUrl = action.payload;
  },

  setIsTransferredFromRpm: (state, action) => {
    state.isTransferredFromRpm = action.payload;
  },

  setRpmReportFile: (state, action) => {
    state.rpmReportFile = action.payload;
  },

  setRpmPatientBilling: (state, action) => {
    state.rpmPatientBilling = action.payload;
  },

  resetRpmPatientValues: (state, action) => {
    state.rpmReport = null;
    state.rpmReportUrl = null;
    state.rpmReportFile = null;
    state.rpmPatientBilling = null;
    state.selectedRpmPatient = null;
    state.isTransferredFromRpm = false;
  },
};
